import { render, staticRenderFns } from "./SystemFlags.vue?vue&type=template&id=1d776942&scoped=true&"
import script from "./SystemFlags.vue?vue&type=script&lang=js&"
export * from "./SystemFlags.vue?vue&type=script&lang=js&"
import style0 from "./SystemFlags.vue?vue&type=style&index=0&id=1d776942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d776942",
  null
  
)

export default component.exports